import ModalsUtil from '../../../utils/modals';
import Language from '../../../language';

export default () => {
    return (
        <div className="modal modal-messages animate__zoomIn animate__animated" data-target="messages" style={{display: 'none'}}>
            <div className="modal-background"></div>
            <div className="modal-close" onClick={() => ModalsUtil.close()}></div> 
            <div className="buttons">
                <div className="button profile">
                    <div className="text" onClick={() => ModalsUtil.open('profile')}>{Language('modals.profile.nav.profile')}</div>
                </div>
                <div className="button information">
                    <div className="text">{Language('modals.profile.nav.information')}</div>
                    {/* <div className="count">2</div> */}
                </div>
            </div>
            <div className="content">

            </div>
            <div className="total">{Language('modals.profile.information.count', {count: 0})}</div>
        </div>
    )
}